import moment from "moment";
import { getSettingById } from "@/collections/settings";
import { getLastPayment } from "@/collections/payments";
import {
  saveUiMenuOrder,
  uiMenuOrderCollection
} from "@/collections/uiMenuOrder";
import {
  saveScheduleFood,
  scheduleFoodCollection
} from "@/collections/scheduleFood";
import {
  saveScheduleDrink,
  scheduleDrinksCollection
} from "@/collections/scheduleDrinks";
import {
  saveScheduleDessert,
  scheduleDessertCollection
} from "@/collections/scheduleDessert";
import {
  productTypesCollection,
  saveProductTypeCart
} from "@/collections/productTypes";
import {
  getLastZclousureClosed,
  getLastZclousureOpened,
  saveZclousure,
  updateZclousure
} from "@/collections/zClousures";

const SCHEDULE_DEFAULT = [
  { first: { init: 9, fin: 16 }, second: { init: 19, fin: 23 } },
  { first: { init: 9, fin: 16 }, second: { init: 19, fin: 23 } },
  { first: { init: 9, fin: 16 }, second: { init: 19, fin: 23 } },
  { first: { init: 9, fin: 16 }, second: { init: 19, fin: 23 } },
  { first: { init: 9, fin: 16 }, second: { init: 19, fin: 23 } },
  { first: { init: 9, fin: 16 }, second: { init: 19, fin: 23 } },
  { first: { init: 9, fin: 16 }, second: { init: 19, fin: 23 } }
];

const PAYMENT_METHOD_CASH = "cash";
const PAYMENT_METHOD_DATOFONO = "datafono";
const PAYMENT_METHOD_GOOGLE_PAY = "googlepay";
const PAYMENT_METHOD_APPLE_PAY = "applepay";
const PAYMENT_METHOD_BIZUM = "bizum";

export default {
  data() {
    return {
      paymentMethodCash: PAYMENT_METHOD_CASH,
      paymentMethodDatafono: PAYMENT_METHOD_DATOFONO,
      paymentMethodGooglePay: PAYMENT_METHOD_GOOGLE_PAY,
      paymentMethodApplePay: PAYMENT_METHOD_APPLE_PAY,
      paymentMethodBizum: PAYMENT_METHOD_BIZUM
    };
  },
  methods: {
    async initProject() {
      try {
        uiMenuOrderCollection.get().then(async querySnapshot => {
          try {
            let existsDrinks = false;
            let existsFood = false;
            let existsDessert = false;
            querySnapshot.forEach(function(doc) {
              if (doc.id === process.env.VUE_APP_PRODUCT_TYPE_FOOD_ID) {
                existsFood = true;
              }

              if (doc.id === process.env.VUE_APP_PRODUCT_TYPE_DRINKS_ID) {
                existsDrinks = true;
              }

              if (doc.id === process.env.VUE_APP_PRODUCT_TYPE_DESSERT_ID) {
                existsDessert = true;
              }
            });

            if (!existsFood) {
              await saveUiMenuOrder(process.env.VUE_APP_PRODUCT_TYPE_FOOD_ID, {
                id: process.env.VUE_APP_PRODUCT_TYPE_FOOD_ID,
                name: "Comidas",
                active: true,
                type: "principal",
                sort: 1
              }).then();
            }

            if (!existsDrinks) {
              await saveUiMenuOrder(
                process.env.VUE_APP_PRODUCT_TYPE_DRINKS_ID,
                {
                  id: process.env.VUE_APP_PRODUCT_TYPE_DRINKS_ID,
                  name: "Bebidas",
                  active: true,
                  type: "principal",
                  sort: 2
                }
              ).then();
            }

            if (!existsDessert) {
              await saveUiMenuOrder(
                process.env.VUE_APP_PRODUCT_TYPE_DESSERT_ID,
                {
                  id: process.env.VUE_APP_PRODUCT_TYPE_DESSERT_ID,
                  name: "Postres",
                  active: true,
                  type: "principal",
                  sort: 3
                }
              ).then();
            }
          } catch (error) {
            this.setlogError(
              "save_ui_menu_order",
              "Obtained error message in initProject()",
              error.stack,
              this.$options.name
            );
          }
        });

        productTypesCollection.get().then(async querySnapshot => {
          try {
            let existsDrinks = false;
            let existsFood = false;
            let existsDessert = false;
            querySnapshot.forEach(function(doc) {
              if (doc.id === process.env.VUE_APP_PRODUCT_TYPE_FOOD_ID) {
                existsFood = true;
              }

              if (doc.id === process.env.VUE_APP_PRODUCT_TYPE_DRINKS_ID) {
                existsDrinks = true;
              }

              if (doc.id === process.env.VUE_APP_PRODUCT_TYPE_DESSERT_ID) {
                existsDessert = true;
              }
            });

            if (!existsFood) {
              await saveProductTypeCart(
                process.env.VUE_APP_PRODUCT_TYPE_FOOD_ID,
                {
                  name: "Comidas"
                }
              ).then();
            }

            if (!existsDrinks) {
              await saveProductTypeCart(
                process.env.VUE_APP_PRODUCT_TYPE_DRINKS_ID,
                {
                  name: "Bebidas"
                }
              ).then();
            }

            if (!existsDessert) {
              await saveProductTypeCart(
                process.env.VUE_APP_PRODUCT_TYPE_DESSERT_ID,
                {
                  name: "Postres"
                }
              ).then();
            }
          } catch (error) {
            this.setlogError(
              "save_product_type_cart",
              "Obtained error message in initProject()",
              error.stack,
              this.$options.name
            );
          }
        });

        scheduleFoodCollection.get().then(querySnapshot => {
          let exists = false;
          // eslint-disable-next-line no-unused-vars
          querySnapshot.forEach(() => {
            exists = true;
          });

          if (!exists) {
            SCHEDULE_DEFAULT.forEach((item, index) => {
              saveScheduleFood(String(index), item)
                .then()
                .catch(error => {
                  this.setlogError(
                    "save_schedule_food",
                    "Obtained error message in initProject()",
                    error.stack,
                    this.$options.name
                  );
                });
            });
          }
        });

        scheduleDrinksCollection.get().then(querySnapshot => {
          let exists = false;
          // eslint-disable-next-line no-unused-vars
          querySnapshot.forEach(() => {
            exists = true;
          });

          if (!exists) {
            SCHEDULE_DEFAULT.forEach((item, index) => {
              saveScheduleDrink(String(index), item)
                .then()
                .catch(error => {
                  this.setlogError(
                    "save_schedule_drink",
                    "Obtained error message in initProject()",
                    error.stack,
                    this.$options.name
                  );
                });
            });
          }
        });

        scheduleDessertCollection.get().then(querySnapshot => {
          let exists = false;
          // eslint-disable-next-line no-unused-vars
          querySnapshot.forEach(() => {
            exists = true;
          });

          if (!exists) {
            SCHEDULE_DEFAULT.forEach((item, index) => {
              saveScheduleDessert(String(index), item)
                .then()
                .catch(error => {
                  this.setlogError(
                    "save_schedule_dessert",
                    "Obtained error message in initProject()",
                    error.stack,
                    this.$options.name
                  );
                });
            });
          }
        });
      } catch (error) {
        this.setlogError(
          "scheduleDessertCollection/scheduleDrinksCollection/scheduleFoodCollection/productTypesCollection/uiMenuOrderCollection",
          "Obtained error message in initProject()",
          error.stack,
          this.$options.name
        );
      }
    },
    async getNextNumber() {
      try {
        let prevSnapshot = await getLastPayment();

        let nextNumber = 1;
        if (prevSnapshot) {
          nextNumber = prevSnapshot.number + 1;
        }
        return nextNumber;
      } catch (error) {
        this.setlogError(
          "get_Last_Payment",
          "Obtained error message in getNextNumber()",
          error.stack,
          this.$options.name
        );
      }
    },
    async getNextInvoiceNumber() {
      let setting;
      try {
        setting = await getSettingById("settings");
      } catch (error) {
        this.setlogError(
          "get_setting",
          "Error obteniendo settings",
          error.stack,
          this.$options.name
        );
      }

      //Get invoice number from settings/company
      let current_inv_number = setting.company.inv_number;
      let prev_inv_number = setting.company
        ? setting.company.prev_inv_number
        : "";

      let currInvSplitSeries = false,
        prevInvSplitSeries = false;
      let currInvNumberSeries = false,
        prevInvNumberSeries = false;
      let currInvOnlyNumberSeries = false,
        prevInvOnlyNumberSeries = false;
      let curr_inv_length = "",
        prev_inv_length = "";
      let currNormalSeriesPrefix = "",
        prevNormalSeriesPrefix = "";
      let currSplitNumberPrefix = "",
        prevSplitNumberPrefix = "";

      //If empty invoice in settings/company
      if (!current_inv_number) {
        this.showInfoMessage(
          "Debes completar el campo Numeración de Factura en Settings/Información de la Empresa"
        );
        let prevNumber = prev_inv_number;
        console.log("prevNumber", prevNumber);
        let checkNumberType = /^\d+$/.test(prevNumber);
        console.log("type", checkNumberType);
        if (checkNumberType) {
          return JSON.stringify(parseInt(prevNumber) + 1);
        } else {
          return "1";
        }
      }

      // Find type - FUN001-2021-000000
      let currSplitNumberSeries = current_inv_number.includes("-")
        ? current_inv_number.split("-")
        : [];
      console.log("currSplitNumber", currSplitNumberSeries);
      let prevSplitNumberSeries = prev_inv_number?.includes("-")
        ? prev_inv_number?.split("-")
        : [];

      // Find type - FUN
      for (let i = 0; i < current_inv_number.length; i++) {
        let n = current_inv_number.charCodeAt(i);
        if ((n >= 65 && n <= 90) || (n >= 97 && n <= 122)) {
          curr_inv_length += current_inv_number[i];
        } else {
          break;
        }
      }

      // Find type - FUN
      if (prev_inv_number) {
        for (let j = 0; j < prev_inv_number.length; j++) {
          let n = prev_inv_number.charCodeAt(j);
          if ((n >= 65 && n <= 90) || (n >= 97 && n <= 122)) {
            prev_inv_length += prev_inv_number[j];
          } else {
            break;
          }
        }
      }
      //Checking the type of series
      if (current_inv_number) {
        currInvOnlyNumberSeries = /^\d+$/.test(current_inv_number);
        currInvSplitSeries = currSplitNumberSeries.length > 0;
        currInvNumberSeries = !currInvSplitSeries && curr_inv_length.length > 0;
      }
      if (prev_inv_number) {
        prevInvOnlyNumberSeries = /^\d+$/.test(prev_inv_number);
        prevInvSplitSeries = prevSplitNumberSeries.length > 0;
        prevInvNumberSeries = !prevInvSplitSeries && prev_inv_length.length > 0;
      }

      // FUN0012021000000
      if (currInvNumberSeries) {
        currNormalSeriesPrefix = current_inv_number.substring(
          0,
          curr_inv_length.length
        );
      }
      if (prevInvNumberSeries) {
        prevNormalSeriesPrefix = prev_inv_number.substring(
          0,
          prev_inv_length.length
        );
      }

      if (currInvSplitSeries) {
        currSplitNumberPrefix = currSplitNumberSeries.splice(
          0,
          currSplitNumberSeries.length - 1
        );
        currSplitNumberPrefix = currSplitNumberPrefix.join("-");
      }

      if (prevInvSplitSeries) {
        prevSplitNumberPrefix = prevSplitNumberSeries.splice(
          0,
          prevSplitNumberSeries.length - 1
        );
        prevSplitNumberPrefix = prevSplitNumberPrefix.join("-");
      }

      //valdidation
      if (
        (currInvSplitSeries &&
          prevInvSplitSeries &&
          currSplitNumberPrefix !== prevSplitNumberPrefix) ||
        (currInvSplitSeries &&
          prevInvNumberSeries &&
          currSplitNumberPrefix !== prevNormalSeriesPrefix) ||
        (currInvOnlyNumberSeries && (prevInvSplitSeries || prevInvNumberSeries))
      ) {
        prev_inv_number = "";
      }

      if (
        (currInvNumberSeries &&
          prevInvNumberSeries &&
          currNormalSeriesPrefix !== prevNormalSeriesPrefix) ||
        (currInvNumberSeries &&
          prevInvSplitSeries &&
          currNormalSeriesPrefix !== prevSplitNumberPrefix) ||
        (prevInvOnlyNumberSeries && (currInvSplitSeries || currInvNumberSeries))
      ) {
        prev_inv_number = "";
      }

      let currSplitNumberPostfix = "",
        prevSplitNumberPostfix = "",
        nextNumber = "",
        zeros = "",
        nextNumberLength = null,
        nextInvoice = "";

      if (prev_inv_number) {
        //If series with "-"
        if (prevInvSplitSeries) {
          prevSplitNumberPostfix =
            prevSplitNumberSeries[prevSplitNumberSeries.length - 1];
          nextNumber = JSON.stringify(parseInt(prevSplitNumberPostfix) + 1);
          nextNumberLength = nextNumber.length;
          zeros = "0".repeat(prevSplitNumberPostfix.length - nextNumberLength);
          nextInvoice = prevSplitNumberPrefix + "-" + zeros + nextNumber;
        } else {
          if (prevInvOnlyNumberSeries) {
            //only digit input
            nextInvoice = JSON.stringify(parseInt(prev_inv_number) + 1);
          } else {
            //alphabets + digits
            let regex = /\d+/g;
            let number_matches = prev_inv_number.match(regex);
            // get last numbers from string
            let prevNormalSeriesPostfix =
              number_matches[number_matches.length - 1];
            nextNumber = JSON.stringify(parseInt(prevNormalSeriesPostfix) + 1);
            nextNumberLength = nextNumber.length;
            zeros = "0".repeat(
              prevNormalSeriesPostfix.length - nextNumberLength
            );
            nextInvoice = prevNormalSeriesPrefix + zeros + nextNumber;
          }
        }
      } else {
        if (currInvSplitSeries) {
          currSplitNumberPostfix =
            currSplitNumberSeries[currSplitNumberSeries.length - 1];
          nextNumber = JSON.stringify(parseInt(currSplitNumberPostfix) + 1);
          nextNumberLength = nextNumber.length;
          zeros = "0".repeat(currSplitNumberPostfix.length - nextNumberLength);
          nextInvoice = currSplitNumberPrefix + "-" + zeros + nextNumber;
        } else {
          if (currInvOnlyNumberSeries) {
            nextInvoice = JSON.stringify(parseInt(current_inv_number) + 1);
          } else {
            //alphabets + digits
            let regex = /\d+/g;
            let number_matches = current_inv_number.match(regex);
            // get last numbers from string
            let currNormalSeriesPostfix =
              number_matches[number_matches.length - 1];
            nextNumber = JSON.stringify(parseInt(currNormalSeriesPostfix) + 1);
            nextNumberLength = nextNumber.length;
            zeros = "0".repeat(
              currNormalSeriesPostfix.length - nextNumberLength
            );
            nextInvoice = currNormalSeriesPrefix + zeros + nextNumber;
          }
        }
      }
      return nextInvoice;
    },
    async getzClosureIdAndUpdateWithPaymentMethodGiven(
      paymentMethod,
      fromUser = true
    ) {
      let nextId = 1;

      // UPDATE Z_CLOUSURE
      // check if existing zCloures opened
      let lastZclousureOpened = await this.getLastZclousureOpened();

      if (lastZclousureOpened && lastZclousureOpened.size) {
        let _doc = lastZclousureOpened.docs[0];
        console.log(_doc.data());

        nextId = parseInt(_doc.id);
        this.updatezClousureWithPaymentMethodGiven(
          paymentMethod,
          nextId,
          _doc.data(),
          fromUser
        );

        return nextId;
      }

      // NEW Z_CLOUSURE
      let lastZclousureClosed = await this.getLastZclousureClosed();

      let totalChangeCountAccumulated = null;
      if (lastZclousureClosed.size) {
        let _doc = lastZclousureClosed.docs[0];
        console.log(_doc.data());

        nextId = parseInt(_doc.id) + 1;
        totalChangeCountAccumulated = _doc.data().total_change_count;
      }

      this.createzClousureWithPaymentMethodGiven(
        paymentMethod,
        nextId,
        totalChangeCountAccumulated,
        moment().toDate(),
        fromUser
      );

      return nextId ? nextId : 1;
    },
    async getLastZclousureOpened() {
      try {
        return await getLastZclousureOpened();
      } catch (error) {
        this.setlogError(
          "get_last_zclousure_opened",
          "Obtained error message in getLastZclousureOpened()",
          error.stack,
          this.$options.name
        );
      }
    },
    async getLastZclousureClosed() {
      try {
        return await getLastZclousureClosed();
      } catch (error) {
        this.setlogError(
          "get_last_zclousure_closed",
          "Obtained error message in getLastZclousureClosed()",
          error.stack,
          this.$options.name
        );
      }
    },
    async updatezClousureWithPaymentMethodGiven(
      paymentMethod,
      nextId,
      _data,
      fromUser = true
    ) {
      try {
        if (paymentMethod === PAYMENT_METHOD_CASH) {
          await updateZclousure(nextId.toString(), {
            total_invoiced_in_cash:
              parseFloat(_data.total_invoiced_in_cash) +
              parseFloat(
                !fromUser
                  ? this.data.amount
                  : this.payment.cash_payment.amount_to_pay
              )
          });

          return;
        }

        if (paymentMethod === PAYMENT_METHOD_DATOFONO) {
          await updateZclousure(nextId, {
            total_invoiced_in_datafono:
              parseFloat(_data.total_invoiced_in_datafono) +
              parseFloat(
                !fromUser
                  ? this.data.amount
                  : this.payment.datafono_payment.amount_to_pay
              )
          });

          return;
        }

        if (paymentMethod === PAYMENT_METHOD_GOOGLE_PAY) {
          await updateZclousure(nextId, {
            total_invoiced_in_google_pay:
              parseFloat(_data.total_invoiced_in_google_pay) +
              parseFloat(this.amountPaid)
          });

          return;
        }

        if (paymentMethod === PAYMENT_METHOD_APPLE_PAY) {
          await updateZclousure(nextId, {
            total_invoiced_in_apple_pay:
              parseFloat(_data.total_invoiced_in_apple_pay) +
              parseFloat(this.amountPaid)
          });

          return;
        }

        if (paymentMethod === PAYMENT_METHOD_BIZUM) {
          await updateZclousure(nextId, {
            total_invoiced_in_bizum:
              parseFloat(_data.total_invoiced_in_bizum) +
              parseFloat(this.amountPaid)
          });

          return;
        }

        await updateZclousure(nextId, {
          total_invoiced_on_credit_card:
            parseFloat(_data.total_invoiced_on_credit_card) +
            parseFloat(this.amountPaid)
        });
      } catch (error) {
        this.setlogError(
          "update_zclousure",
          "Obtained error message in updatezClousureWithPaymentMethodGiven()",
          error.stack,
          this.$options.name
        );
      }
    },
    async createzClousureWithPaymentMethodGiven(
      paymentMethod,
      nextId,
      totalChangeCountAccumulated,
      now,
      fromUser = true
    ) {
      try {
        if (paymentMethod === PAYMENT_METHOD_CASH) {
          await saveZclousure(nextId, {
            opened_on: now,
            closed_on: null,
            total_invoiced_in_cash: parseFloat(
              !fromUser
                ? this.data.amount
                : this.payment.cash_payment.amount_to_pay
            ),
            total_invoiced_on_credit_card: 0,
            total_invoiced_in_datafono: 0,
            total_invoiced_in_google_pay: 0,
            total_invoiced_in_apple_pay: 0,
            total_invoiced_in_bizum: 0,
            total_change_count_accumulated: totalChangeCountAccumulated
          });

          return;
        }

        if (paymentMethod === PAYMENT_METHOD_DATOFONO) {
          await saveZclousure(nextId, {
            opened_on: now,
            closed_on: null,
            total_invoiced_in_datafono: parseFloat(
              !fromUser
                ? this.data.amount
                : this.payment.datafono_payment.amount_to_pay
            ),
            total_invoiced_on_credit_card: 0,
            total_invoiced_in_cash: 0,
            total_invoiced_in_google_pay: 0,
            total_invoiced_in_apple_pay: 0,
            total_invoiced_in_bizum: 0,
            total_change_count_accumulated: totalChangeCountAccumulated
          });

          return;
        }

        if (paymentMethod === PAYMENT_METHOD_GOOGLE_PAY) {
          await saveZclousure(nextId, {
            opened_on: now,
            closed_on: null,
            total_invoiced_in_google_pay: parseFloat(this.amountPaid),
            total_invoiced_on_credit_card: 0,
            total_invoiced_in_cash: 0,
            total_invoiced_in_datafono: 0,
            total_invoiced_in_apple_pay: 0,
            total_invoiced_in_bizum: 0,
            total_change_count_accumulated: totalChangeCountAccumulated
          });

          return;
        }

        if (paymentMethod === PAYMENT_METHOD_APPLE_PAY) {
          await saveZclousure(nextId, {
            opened_on: now,
            closed_on: null,
            total_invoiced_in_google_pay: 0,
            total_invoiced_on_credit_card: 0,
            total_invoiced_in_cash: 0,
            total_invoiced_in_datafono: 0,
            total_invoiced_in_apple_pay: parseFloat(this.amountPaid),
            total_invoiced_in_bizum: 0,
            total_change_count_accumulated: totalChangeCountAccumulated
          });

          return;
        }

        if (paymentMethod === PAYMENT_METHOD_BIZUM) {
          await saveZclousure(nextId, {
            opened_on: now,
            closed_on: null,
            total_invoiced_in_google_pay: 0,
            total_invoiced_on_credit_card: 0,
            total_invoiced_in_cash: 0,
            total_invoiced_in_datafono: 0,
            total_invoiced_in_apple_pay: 0,
            total_invoiced_in_bizum: parseFloat(this.amountPaid),
            total_change_count_accumulated: totalChangeCountAccumulated
          });

          return;
        }

        await saveZclousure(nextId, {
          opened_on: now,
          closed_on: null,
          total_invoiced_in_cash: 0,
          total_invoiced_in_datafono: 0,
          total_invoiced_on_credit_card: parseFloat(this.amountPaid),
          total_invoiced_in_google_pay: 0,
          total_invoiced_in_apple_pay: 0,
          total_invoiced_in_bizum: 0,
          total_change_count_accumulated: totalChangeCountAccumulated
        });
      } catch (error) {
        this.setlogError(
          "save_zclousure",
          "Obtained error message in createzClousureWithPaymentMethodGiven()",
          error.stack,
          this.$options.name
        );
      }
    }
  }
};
